var render = function () {
  var _vm$detail, _vm$detail$companyApp, _vm$detail2, _vm$detail2$companyAp, _vm$detail$companyApp2, _vm$detail$companyApp3, _vm$detail$companyApp4, _vm$detail$companyApp5, _vm$detail$companyApp6, _vm$detail$companyApp7, _vm$detail$supplier, _vm$detail$supplier2, _vm$detail$supplier3, _vm$detail3, _vm$detail3$invoice;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "desp"
  }, [_c('div', {
    staticClass: "desp-header"
  }, [_vm._v("Confirmation:")]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title-icon"
  }, [_c('svg-icon', {
    staticClass: "jump-icon",
    attrs: {
      "name": "applicant"
    }
  }), _vm._v(" Applicant information ")], 1), _c('div', {
    staticClass: "desp-items-wrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Applicant Name")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.applicantName))])])]), _vm.detail.companyApplyment ? [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Mobile")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.companyApplyment.applicantPhone))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Email")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.companyApplyment.applicantEmail))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Residential Address")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.companyApplyment.residentialAddress))])])]), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Applicant role")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(" " + _vm._s(_vm.applicantPositionFormat(_vm.detail.companyApplyment.applicantPosition)) + " ")])])])] : _vm._e()], 2)], 1)]), _vm.detail.companyApplyment ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title-icon"
  }, [_c('svg-icon', {
    staticClass: "jump-icon",
    attrs: {
      "name": "country"
    }
  }), _vm._v(" Location of the proposed company ")], 1), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_vm._v(_vm._s(_vm.detail.companyApplyment.country))])])]) : _vm._e(), _vm.detail.orderType == 'generic' || _vm.detail.orderType == 'quotation_part' ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title-icon"
  }, [_c('svg-icon', {
    staticClass: "jump-icon",
    attrs: {
      "name": "planAndServices"
    }
  }), _vm._v(" Choice of service(s) ")], 1), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_c('div', {
    staticClass: "mt10"
  }, [_vm.detail.orderType == 'generic' ? [((_vm$detail = _vm.detail) === null || _vm$detail === void 0 ? void 0 : (_vm$detail$companyApp = _vm$detail.companyApplyment) === null || _vm$detail$companyApp === void 0 ? void 0 : _vm$detail$companyApp.goodsListType) == 1 ? [_c('Package', {
    attrs: {
      "goodsList": _vm.detail.goodsList
    }
  })] : _vm._e(), ((_vm$detail2 = _vm.detail) === null || _vm$detail2 === void 0 ? void 0 : (_vm$detail2$companyAp = _vm$detail2.companyApplyment) === null || _vm$detail2$companyAp === void 0 ? void 0 : _vm$detail2$companyAp.goodsListType) == 2 ? [_c('diy-package', {
    attrs: {
      "businessType": _vm.detail.businessType,
      "goodsList": _vm.detail.goodsList
    }
  })] : _vm._e()] : _vm._e(), _vm.detail.orderType == 'quotation_part' ? [_c('quotation-subtotal', {
    attrs: {
      "businessType": _vm.detail.businessType,
      "quotationPart": _vm.detail.quotationPart,
      "billingCurrency": _vm.detail.billingCurrency
    }
  })] : _vm._e()], 2)])])]) : _vm._e(), _vm.detail.orderType == 'adjustment' ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Quotation (V)")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_c('div', {
    staticClass: "mt10"
  }, [_c('quotation-v-single', {
    attrs: {
      "detail": _vm.detail
    }
  })], 1)])])]) : _vm._e(), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Order")]), _c('div', {
    staticClass: "desp-items-wrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Transaction No.")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.businessNo))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Order No.")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.orderNo))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Create Time")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.createTime))])])]), _vm.detail.companyApplyment ? [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Coordinator")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(" " + _vm._s(((_vm$detail$companyApp2 = _vm.detail.companyApplyment) === null || _vm$detail$companyApp2 === void 0 ? void 0 : (_vm$detail$companyApp3 = _vm$detail$companyApp2.coordinator) === null || _vm$detail$companyApp3 === void 0 ? void 0 : _vm$detail$companyApp3.nickname) || "") + " ")])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Checker")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(" " + _vm._s(((_vm$detail$companyApp4 = _vm.detail.companyApplyment) === null || _vm$detail$companyApp4 === void 0 ? void 0 : (_vm$detail$companyApp5 = _vm$detail$companyApp4.checker) === null || _vm$detail$companyApp5 === void 0 ? void 0 : _vm$detail$companyApp5.nickname) || "") + " ")])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Reviewer")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(" " + _vm._s(((_vm$detail$companyApp6 = _vm.detail.companyApplyment) === null || _vm$detail$companyApp6 === void 0 ? void 0 : (_vm$detail$companyApp7 = _vm$detail$companyApp6.auditor) === null || _vm$detail$companyApp7 === void 0 ? void 0 : _vm$detail$companyApp7.nickname) || "") + " ")])])])] : _vm._e(), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Pay Type")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.payTypesFormat(_vm.detail.payType)))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Transfer Remark")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.transferVerifyRemark))])])])], 2)], 1)]), _vm.detail.supplier ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Supplier")]), _c('div', {
    staticClass: "desp-items-wrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Abbreviation")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(((_vm$detail$supplier = _vm.detail.supplier) === null || _vm$detail$supplier === void 0 ? void 0 : _vm$detail$supplier.abbr) || ""))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Company Name")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(((_vm$detail$supplier2 = _vm.detail.supplier) === null || _vm$detail$supplier2 === void 0 ? void 0 : _vm$detail$supplier2.companyName) || ""))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Country")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(((_vm$detail$supplier3 = _vm.detail.supplier) === null || _vm$detail$supplier3 === void 0 ? void 0 : _vm$detail$supplier3.country) || ""))])])])], 1)], 1)]) : _vm._e(), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Generic Invoice")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [(_vm$detail3 = _vm.detail) !== null && _vm$detail3 !== void 0 && (_vm$detail3$invoice = _vm$detail3.invoice) !== null && _vm$detail3$invoice !== void 0 && _vm$detail3$invoice.invoiceNumber ? _c('span', {
    staticClass: "mr40 to-link",
    on: {
      "click": function click($event) {
        var _vm$detail4, _vm$detail4$invoice;

        return _vm.invoiceLink((_vm$detail4 = _vm.detail) === null || _vm$detail4 === void 0 ? void 0 : (_vm$detail4$invoice = _vm$detail4.invoice) === null || _vm$detail4$invoice === void 0 ? void 0 : _vm$detail4$invoice.invoiceNumber);
      }
    }
  }, [_vm._v("Invoice")]) : _vm._e()])])]), _vm.detail.status == 'COMPLETE' && _vm.detail.isInvoiceRevised ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Revised Invoice")]), _c('div', {
    staticClass: "desp-item"
  }, [_vm.detail.revisedInvoiceFile ? _c('div', {
    staticClass: "desp-item-self"
  }, [_c('a', {
    staticClass: "to-link",
    attrs: {
      "href": _vm.detail.revisedInvoiceFile.url,
      "target": "_target"
    }
  }, [_vm._v(" " + _vm._s(_vm.detail.revisedInvoiceFile.name) + " ")])]) : _vm._e()])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }